import { useContext, useEffect, useRef, useState } from "react"
import { ApiGetCall, ApiGetCDNData, ApiPostCall } from "../../JS/Connector";
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, getTypeWatchDelay, HideLoder, MMDDYYYY, ShowLoder, typewatch } from "../../JS/Common";
import AlertsComp from "../../Components/AlertsComp";
import { faExclamationTriangle, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckValidation } from "../../Components/Validations";
import Popup from "../../Components/Popup";
import { useNavigate } from "react-router-dom";
import Deletepopup from "../../Components/Deletepopup";
import SignatureCanvas from "react-signature-canvas";
import Pagination from "react-js-pagination";
import PageHead from "../../Components/PageHead";
import { useSelector } from "react-redux";
import CustomFontAwesomeIcon from "../../Components/CustomFontAwesomeIcon";
import useConfig from "../../Hooks/useConfig";
import { log } from "../../JS/Logger";
import Tab from "../../Components/Tab";
import { useStickyAction } from "../../Hooks";

export function PricingActivation() {
    const { organization, students, adminCallNode, dcc_module_text } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const [GridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [detailspopup, setdetailspopup] = useState(false);
    const [PlanDetails, setPlanDetails] = useState("");
    const [totalprice, setTotalPrice] = useState(0);
    const [Schoolid, setSchoolid] = useState("");
    const [planstatus, setplanstatus] = useState("");
    const [Alerts, setNewAlerts] = useState("");
    const [Schools, setSchools] = useState([]);
    const [SchoolValue, setSchoolValue] = useState('');
    const [searchstring, setsearchstring] = useState('')
    const [SortFlag, setSortFlag] = useState('')
    const [sortingDetails, setSortingDetails] = useState({
        column: null,
        sortFlag: "desc",
    });
    const [activeFilter, setActiveFilter] = useState(null);
    const [resetFilter, setResetFilter] = useState('d-none')
    const [Previewflag, setPreviewflag] = useState(1)
    const [UncoveredCharge, setUncoveredCharge] = useState(0);
    const [showdeletepopup, setshowdeletepopup] = useState(false);
    const [ShopifyPopup, setShopifyPopup] = useState(false);
    const [SignatureData, setSignatureData] = useState('')
    const [signatureModal, setSignatureModal] = useState(false)
    const [signatureData, setsignatureData] = useState({
        schoolid: "",
    })
    const navigate = useNavigate();
    const sigCanvas = useRef({});
    const [deleteplanvalue, setdeleteplavalue] = useState({
        schoolid: '',
        planid: ''
    })
    const [shopifyData, setShopifyData] = useState({
        pageLink: '',
        discountCode: '',
        planid: '',
        schoolid: ''
    })
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const showPagination = GridData?.length > 0;
    const itemsPerPage = LimitForPagination;
    const { tableWrapperRef, isOverflowing } = useStickyAction(GridData);

    useEffect(() => {
        ApiGetCall("/schools/with-insurance-plans").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.msg?.length != 0) {
                    const sortedSchools = responseRs.msg.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                    setSchools(sortedSchools);
                } else {
                    setSchools([]);
                }
                setLoading(false);
            }
        });
    }, []);
    useEffect(() => {
        AllPlans(SchoolValue, searchstring, Tabactive.Expired == "active" ? 4 : activeFilter)
    }, [currentPage, LimitForPagination, sortingDetails])
    async function AllPlans(sclid, searchString, sortFlag) {
        if (!searchString) searchString = null;
        if (!sortFlag) sortFlag = null;
        if (!sclid) sclid = null;
        if (sortFlag != null) {
            setResetFilter('')
        } else {
            setResetFilter('d-none')
            setActiveFilter(null)
        }
        setSchoolid(sclid);
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`${adminCallNode}/plans/all-paged?schoolId=${sclid}&search=${searchString}&planFlag=${sortFlag}&sortBy=${sortingDetails.column}&sortByOrder=${sortingDetails.sortFlag}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setGridData(responseRs?.data?.length ? responseRs?.data : [])
                    setpageRangeCount(responseRs.total)
                }
            });
        }, getTypeWatchDelay(searchString, 500));
    }
    async function ShowPricingDetails(planid) {
        setdetailspopup(true);
        setPreviewflag(1);
        setLoading(true)
        await ApiGetCall(`${adminCallNode}/plans/all-for-admin?planId=${planid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setSchoolid(responseRs.school_id);
                setPlanDetails(responseRs);
                setUncoveredCharge(responseRs.uncovered_charge);
                setplanstatus(responseRs.status)
                setTotalPrice(responseRs.price || 0)
            }
        });
    }
    async function SavePricingDetails() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: Schoolid,
            planId: PlanDetails.id,
            uncoveredCharge: UncoveredCharge,
            planPrice: totalprice,
            planStatus: planstatus
        });
        await ApiPostCall("/plans/insurance/set-services-price", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Prices Updated Successfully."} />);
                    setdetailspopup(false);
                    setPlanDetails("");
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        AllPlans(null, null, Tabactive.Expired == "active" ? 4 : null);
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    function FilterBySch(e) {
        if (e.target.value == 0) {
            AllPlans(null, null, Tabactive.Expired == "active" ? 4 : null)
        } else {
            AllPlans(e.target.value, searchstring, Tabactive.Expired == "active" ? 4 : SortFlag)
        }
    }
    function ContinueClick() {
        var isFormValid = CheckValidation({ formID: 'uncoveredchargediv' });
        if (!isFormValid) return;
    }
    const modalBody = (
        <div className="row">
            <div className="col-lg-6 py-2 pe-0 wordwrap">
                <div className="col-md-12  fw-600 font-13">Club Name : </div>
                <div className="col-md-12 mb-0 schoolColorStatus h5"> {PlanDetails.plan_name}</div>
            </div>
            <div className="col-lg-6  py-2 pe-0 wordwrap">
                <div className="col-md-12 fw-600 font-13">Grades: </div>
                <div className="col-md-12"> {PlanDetails.grades}</div>
            </div>
            <div className="col-lg-6  py-2 pe-0 wordwrap">
                <div className="col-md-12 fw-600 font-13">Sign Up Start Date: </div>
                <div className="col-md-12"> {PlanDetails.start_date ? formatDateToMMDDYYYY(PlanDetails.start_date) : '-'}</div>
            </div>
            <div className="col-lg-6  py-2 pe-0 wordwrap">
                <div className="col-md-12 fw-600 font-13">Sign Up End Date: </div>
                <div className="col-md-12"> {PlanDetails.end_date ? formatDateToMMDDYYYY(PlanDetails.end_date) : '-'}</div>
            </div>
            <div className="col-lg-6  py-2 pe-0 wordwrap">
                <div className="col-md-12 fw-600 font-13">{dcc_module_text} Start Date: </div>
                <div className="col-md-12"> {PlanDetails.coverage_start_date ? formatDateToMMDDYYYY(PlanDetails.coverage_start_date) : '-'}</div>
            </div>
            <div className="col-lg-6  py-2 pe-0 wordwrap">
                <div className="col-md-12 fw-600 font-13">{dcc_module_text} End Date: </div>
                <div className="col-md-12"> {PlanDetails.coverage_end_date ? formatDateToMMDDYYYY(PlanDetails.coverage_end_date) : '-'}</div>
            </div>
            <div className="col-lg-6 py-2 pe-0 wordwrap">
                <div className="col-md-12  fw-600 font-13">{organization} Contact Name  : </div>
                <div className="col-md-12"> {PlanDetails.contact_name}</div>
            </div>
            <div className="col-lg-6 py-2 pe-0 wordwrap">
                <div className="col-md-12  fw-600 font-13">{organization} Contact Email : </div>
                <div className="col-md-12"> {PlanDetails.contact_email}</div>
            </div>
            <div className="col-lg-6 py-2 pe-0 wordwrap">
                <div className="col-md-12  fw-600 font-13">Estimated  {students} Enrollment  : </div>
                <div className="col-md-12"> {PlanDetails.estimated_enrollment}</div>
            </div>
            <div className="col-lg-6 py-2 pe-0 wordwrap">
                <div className="col-md-12  fw-600 font-13">Device Models Included : </div>
                <div className="col-md-12">{PlanDetails.device_models} </div>
            </div>
            <div className="col-12  py-2 row pe-0 wordwrap">
                <div className="col-md-6 fw-600 font-13">Percentage of Devices Going Home with  {students || 'students'}: </div>
                <div className="col-md-6"> {PlanDetails.devices_not_leave_school}&nbsp;%</div>
            </div>
            <div className="col-12  py-2 row pe-0 wordwrap">
                <div className="col-md-6 fw-600 font-13">{students} keep devices over summer: </div>
                <div className="col-md-6"> {PlanDetails.keep_device_over_summer == 0 ? "No" : "Yes"}</div>
            </div>
            {PlanDetails.negotiated_price != null && planstatus != 7 && (
                <div className="col-12 row py-2 pe-0 wordwrap">
                    <div className="col-md-6  fw-600 font-13">Negotiated Prices : </div>
                    <div className="col-md-6 mb-0 h5" style={{ color: '#ff9385' }}> <b>${PlanDetails.negotiated_price}</b></div>
                </div>
            )}
            {PlanDetails.rejection_note != null && planstatus != 7 && (
                <div className="col-12 row py-2 pe-0 wordwrap">
                    <div className="col-md-6  fw-600 font-13">Reason for Rejection : </div>
                    <div className="col-md-6 mb-0 h5" style={{ color: '#ff9385' }}> <b>{PlanDetails.rejection_note}</b></div>
                </div>
            )}
            <div className="col-lg-12 row align-items-center py-1 parent" id="uncoveredchargediv">

                <div className={`col-12 row ${PlanDetails?.school?.uncovered_repair_charges == 1 ? '' : 'd-none'}`}>
                    <div className="col-md-9 redText">
                        What charges would you like to add for unenrolled repairs?
                    </div>
                    <div className="col-md-3 ps-0">
                        <div className="input-group d-flex">
                            <span className="input-group-text">$</span>
                            <input
                                className="form-control"
                                autoComplete="off"
                                value={UncoveredCharge}
                                type="number"
                                name="uncoveredprice"
                                onChange={(e) => setUncoveredCharge(e.target.value)}
                                min={0}
                                required
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                </div>
                <div className="col-12 row pt-2">
                    <div className="col-md-9">
                        What charges would you like to add for club?
                    </div>
                    <div className="col-md-3 ps-0">
                        <div className="input-group d-flex">
                            <span className="input-group-text">$</span>
                            <input
                                className="form-control"
                                autoComplete="off"
                                value={totalprice}
                                type="number"
                                name="uncoveredprice"
                                onChange={(e) => setTotalPrice(e.target.value)}
                                min={0}
                                required
                                disabled={planstatus == 7}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {Previewflag == 2 && (
                <div className="col-12 mt-3 mb-2 alignment-item-center d-flex justify-content-center zoom-in-out-box">
                    <span><FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "var(--primary-color)", height: "100px", height: '18px' }} className="img-fluid" /></span>
                    <span className="signuplink ps-2">Before proceeding, please verify the prices and other relevant details.</span>
                </div>)}
        </div>
    )
    const shopifymodalBody = (
        <div id='AddShopifyForm' className="parent row">
            <div className='col-12 pb-2'>
                <label className='fw-600 content-forsetupcards py-2'>Shopify page link <label className='redText'>*</label></label>
                <input type="text" name='pagelink' className="form-control" autoComplete='off' required
                    value={shopifyData.pageLink} onChange={(e) => { setShopifyData({ ...shopifyData, pageLink: e.target.value }) }} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-12 py-2'>
                <label className='fw-600 content-forsetupcards py-2'>Discount code <label className='redText'>*</label></label>
                <input type="text" name='discountCode' className="form-control" autoComplete='off' required
                    value={shopifyData.discountCode} onChange={(e) => { setShopifyData({ ...shopifyData, discountCode: e.target.value }) }} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
        </div>
    )
    async function DeletePlan() {
        setLoading(true);
        var raw = "";
        await ApiPostCall("/plans/insurance/delete-unfinished?schoolId=" + deleteplanvalue.schoolid + "&insurancePlanId=" + deleteplanvalue.planid, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setshowdeletepopup(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Club Deleted Successfully."} />);
                    setTimeout(() => {
                        AllPlans(null, null, Tabactive.Expired == "active" ? 4 : null)
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function SaveShopifyDetails() {
        var isFormValid = CheckValidation({ formID: 'AddShopifyForm' });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: shopifyData.schoolid,
            planId: shopifyData.planid,
            shopifyLink: shopifyData.pageLink,
            discountCode: shopifyData.discountCode,
        });
        await ApiPostCall("/plans/insurance/set-link-code", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Shopify Info Added Successfully."} />);
                    setShopifyPopup(false);
                    setShopifyData({ ...shopifyData, pageLink: "", discountCode: "", planid: "", schoolid: "" });
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        AllPlans(null, null, Tabactive.Expired == "active" ? 4 : null);
                    }, 2000);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const clearSignature = () => {
        if (SignatureData != null) {
            setSignatureData(null)
        } else {
            sigCanvas.current.clear();
        }
    };
    const signaturemodalbody = (
        <div className="col-12 py-1">
            <div className="greyBox">
                <div className='fw-600 font-15 text-center'>Admin Signature:</div>
                <div className='mt-2 text-center'>
                    {SignatureData ? (
                        <img src={SignatureData} alt="Packed By Signature" />
                    ) : (
                        <SignatureCanvas
                            ref={sigCanvas}
                            canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                        />
                    )}
                </div>
                <div className="text-end"> <label className="cursor-pointer" onClick={clearSignature}><u>Clear</u></label></div>
            </div>
        </div>
    )
    async function SaveSignatureCall() {
        var signatureBase64 = null;
        if (SignatureData == null) {
            signatureBase64 = sigCanvas.current.isEmpty() ? null : sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        } else {
            signatureBase64 = SignatureData
        }
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: signatureData.schoolid,
            signature: signatureBase64,
        });
        await ApiPostCall(`${adminCallNode}/plans/insurance/parental-agreement/add-signature`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setSignatureModal(false);
                const responseRs = JSON.parse(result);
                if (responseRs.success == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Signature Added Successfully"} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        AllPlans(null, null, Tabactive.Expired == "active" ? 4 : null);
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }
    const downloadDocFile = (parentalagreement) => {
        ApiGetCDNData("/" + parentalagreement, StateData?.Schoolnumber).then((blob) => {
            try {
                const url = URL.createObjectURL(blob);
                if (url) {
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = parentalagreement;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                }
            } catch (err) {
                log.error(err)
            }
        });
    };
    function handleSearchChange(e) {
        setCurrentPage(1);
        AllPlans(SchoolValue, e.target.value, Tabactive.Expired == "active" ? 4 : SortFlag);
        setsearchstring(e.target.value)
    }
    const [Tabactive, setTabActive] = useState({
        Current: "active",
        Expired: "",
    });
    function handleTabClick(tabType) {
        setCurrentPage(1)
        if (tabType == "Current") {
            setTabActive({ ...Tabactive, Current: "active", Expired: "" })
            setSortFlag('')
            AllPlans(SchoolValue, searchstring, '')
        } else if (tabType == "Expired") {
            setTabActive({ ...Tabactive, Current: "", Expired: "active" })
            setSortFlag(4)
            AllPlans(SchoolValue, searchstring, 4)
        }

    }
    const handleSortClick = (item) => {
        item = item.toLowerCase().split(' ').join('_');
        if (item !== 0) {
            setSortingDetails({
                column: item,
                sortFlag: sortingDetails.sortFlag === "asc" ? "desc" : "asc",
            });
            setCurrentPage(1);
        }
    };
    return (
        <>
            {Alerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Pricing and Activation Process"} handleSearch={handleSearchChange}
                loading={loading} showsearch={true} />
            <div className="row pe-0 align-items-center mb-2 me-0">
                <div className="col-md-3 text-end mt-2 offset-md-9">
                    <div className=" ms-2 py-1 pe-0">
                        <select value={SchoolValue} onChange={(e) => { setSchoolValue(e.target.value == "0" ? null : e.target.value); FilterBySch(e); setSchoolid(SchoolValue); setCurrentPage(1) }}>
                            <option value="0">Filter by {organization}</option>
                            {Schools.map((item, j) => (
                                <option value={item.id} key={j}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className='GridBox p-3'>
                <ul className="nav nav-tabs">
                    <Tab isActive={Tabactive.Current == 'active'}
                        label="Current" onClick={() => handleTabClick('Current')} col={'col-md-3'} />
                    <Tab isActive={Tabactive.Expired == 'active'}
                        label="Expired" onClick={() => handleTabClick('Expired')} col={'col-md-3'} />
                </ul>
                <div className="d-flex justify-content-between align-items-baseline pt-3">
                    {Tabactive.Current == "active" &&
                        <><div><u className={`${resetFilter} cursor-pointer`} onClick={(e) => { AllPlans(SchoolValue, null, null); setSortFlag('') }}>Reset All Filter</u></div>
                            <div className="d-flex align-items-center pb-3 flex-wrap">
                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter === 3 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(3); setSortFlag(3); AllPlans(SchoolValue, searchstring, 3); setCurrentPage(1) }}>
                                    <div className="setup-status-square green-backgroung-style mx-3"></div><span>Live</span>
                                </div>
                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 7 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(7); setSortFlag(7); AllPlans(SchoolValue, searchstring, 7); setCurrentPage(1) }}>
                                    <div className="setup-status-square blue-backgroung-style mx-3"></div><span>Live and Unenrolled</span>
                                </div>
                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 2 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(2); setSortFlag(2); AllPlans(SchoolValue, searchstring, 2); setCurrentPage(1) }}>
                                    <div className="setup-status-square purple-backgroung-style mx-3"></div><span>Pending</span>
                                </div>
                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 1 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(1); setSortFlag(1); AllPlans(SchoolValue, searchstring, 1); setCurrentPage(1) }}>
                                    <div className="setup-status-square yellow-backgroung-style mx-3"></div><span>Newly Added</span>
                                </div>


                                {/* <div className={`cursor-pointer d-flex align-items-center ${activeFilter === 4 ? 'activePlanFilter' : ''}`}
                            title="Filter" onClick={(e) => { setActiveFilter(4); setSortFlag(4); AllPlans(SchoolValue, searchstring, 4) }}>
                            <div className="setup-status-square pink-backgroung-style mx-3"></div><span>Past</span>
                        </div> */}
                                {/* <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 5 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(5); setSortFlag(5); AllPlans(SchoolValue, searchstring, 5) }}>
                                    <div className="setup-status-square rejected-backgroung-style mx-3"></div><span>In Negotiation</span>
                                </div> */}


                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 8 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(8); setSortFlag(8); AllPlans(SchoolValue, searchstring, 8); setCurrentPage(1) }}>
                                    <div className="setup-status-square orange-backgroung-style mx-3"></div><span>Sign up Ended</span>
                                </div>
                                <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 6 ? 'activePlanFilter' : ''}`}
                                    title="Filter" onClick={(e) => { setActiveFilter(6); setSortFlag(6); AllPlans(SchoolValue, searchstring, 6); setCurrentPage(1) }}>
                                    <div className="setup-status-square brown-backgroung-style mx-3"></div><span>Rejected</span>
                                </div>
                            </div></>
                    }
                </div >
                <div className="col-12">
                    <label className="redText font-12">*Expired Club Agreement</label>
                </div>
                <div className='col-12 greyBox'>
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table mb-0" >
                            <thead className='GridHeader'>
                                <tr>
                                    <th scope="col" className='cursor-pointer fw-600' title={`Sort by ${organization} name`} onClick={() => { handleSortClick('School Name') }}>
                                        {organization} Name
                                        <img src="/images/sortbynew.svg" alt={`Sort by ${organization} name`} className="img-fluid ps-2 sortbyClass" />

                                    </th>
                                    <th scope="col">Club Name</th>
                                    <th scope="col">Grades</th>
                                    <th scope="col">Price</th>
                                    <th scope="col" className='cursor-pointer fw-600' title="Sort by Start Date" onClick={() => { handleSortClick('Start Date') }}>
                                        Start Date
                                        <img src="/images/sortbynew.svg" alt={`Sort by Start Date`} className="img-fluid ps-2 sortbyClass" />

                                    </th>
                                    <th scope="col" className='cursor-pointer fw-600' title="Sort by End Date" onClick={() => { handleSortClick('Coverage End Date') }}>
                                        End Date
                                        <img src="/images/sortbynew.svg" alt={`Sort by End Date`} className="img-fluid ps-2 sortbyClass" />
                                    </th>
                                    {/* <th scope="col" className='cursor-pointer fw-600' title="Sort by Signup End Date" onClick={() => { handleSortClick('End Date') }}>
                                    Signup End Date
                                    <img src="/images/sortbynew.svg" alt={`Sort by Signup End Date`} className="img-fluid ps-2 sortbyClass" />
                                </th> */}
                                    <th scope="col">Purchases</th>
                                    <th scope="col" className={`${isOverflowing ? 'sticky-action' : ''}`}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {GridData?.length != 0 ?
                                    GridData?.map((item, i) => {
                                        return <tr key={i} className={`OddEvenClass tableBorderHide ${item.parental_agreement_flag == 2 && 'redText'}`} style={{ backgroundColor: item.color_code }}>
                                            <td className='py-12'>{item.school_name}</td>
                                            <td className='py-12'>{item.plan_name}</td>
                                            <td className='py-12'>{item.grades || '-'}</td>
                                            <td className='py-12'>{item.price ? `$${item.price}` : `$0`}</td>
                                            <td className='py-12'>{item.start_date ? MMDDYYYY(item.start_date) : '-'}</td>
                                            <td className='py-12'>{item.coverage_end_date ? MMDDYYYY(item.coverage_end_date) : '-'}</td>
                                            {/* <td className='py-12'>{item.end_date ? MMDDYYYY(item.end_date) : '-'}</td> */}
                                            <td className='py-12'>{item.actual_enrollment_count || '-'}</td>
                                            <td className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                <img src="/images/shopify-brands.svg" title="Add Shopify Info" height="17px" className=" pe-2 cursor-pointer"
                                                    onClick={(e) => { setShopifyPopup(true); setShopifyData({ ...shopifyData, pageLink: item.shopify_link, discountCode: item.discount_code, schoolid: item.school_id, planid: item.id }) }} />
                                                {item.parental_agreement_flag == 1 || item.parental_agreement_flag == 2 ?
                                                    <img src="/images/previewpdficon.svg" className="px-1 cursor-pointer" style={{ height: "18px" }} title="Preview Club Agreement"
                                                        onClick={(e) => downloadDocFile(item.school?.parental_agreement)}
                                                    />
                                                    : null
                                                }
                                                {item.parental_agreement_flag == 1 || item.parental_agreement_flag == 2 ?
                                                    item?.school?.parental_agreement_signed_by_admin != 1 &&
                                                    <CustomFontAwesomeIcon style={{ color: "black" }} icon={faPencilAlt} title="Signature" className="pe-2 cursor-pointer"
                                                        onClick={(e) => {
                                                            setSignatureData(item.batch_delivered_signature);
                                                            setSignatureModal(true);
                                                            setsignatureData({ ...signatureData, schoolid: item.school_id })
                                                        }} />
                                                    : null
                                                }
                                                {Tabactive.Current == 'active' && (item.status == 3 || item.status == 4) ? (
                                                    <img src="/images/EditIconNew.svg" className="cursor-pointer" title='Edit Club Details' onClick={(e) => {
                                                        navigate(`/add-setup`, { state: { id: item.id, fromPage: 'admin', schoolid: item.school_id } });
                                                    }} planid={item.id} />
                                                ) : null}
                                                {item.status == 4 && !item.deleted_at &&
                                                    <img src="/images/DeleteIcon.svg" title="Delete Club" className=" ps-2 cursor-pointer"
                                                        onClick={(e) => { setdeleteplavalue({ ...deleteplanvalue, schoolid: item.school_id, planid: item.id }); setshowdeletepopup(true) }} />
                                                }
                                                {item.status != 3 && item.status != 4 && item.status != 6 && (
                                                    <>
                                                        {item.price != null && (
                                                            <img src="/images/comments-dollar.svg" title="Edit Prices" height="17px" className=" pe-2 cursor-pointer"
                                                                onClick={(e) => ShowPricingDetails(item.id)} />
                                                        )}
                                                        {item.price == null && (
                                                            <img src="/images/comments-dollar.svg" title="Set Prices" height="17px" className=" pe-2 cursor-pointer"
                                                                onClick={(e) => ShowPricingDetails(item.id)} />
                                                        )}
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    })
                                    :
                                    <tr>
                                        <td colSpan={18} className="p-3 text-center">
                                            No Record Found
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {showPagination && (
                        <Pagination
                            activePage={currentPage}
                            itemsCountPerPage={itemsPerPage}
                            totalItemsCount={pageRangeCount}
                            pageRangeDisplayed={15}
                            onChange={(e) => setCurrentPage(e)}
                            color="primary"
                            lastPageText=""
                            firstPageText=""
                            itemClassFirst="MasterClass"
                            itemClassPrev="MasterClass"
                            itemClassNext="MasterClass"
                            itemClassLast="MasterClass"
                            hideFirstLastPages={true} />
                    )}
                </div>
            </div >
            <Popup isshow={detailspopup} size={"lg"} title={"Pricing and Activation Process"}
                closePopup={(e) => { setdetailspopup(false); setPlanDetails(""); setUncoveredCharge(0); }}
                modalBody={modalBody} handleSave={() => {
                    if (Previewflag === 1) {
                        ContinueClick();
                        setPreviewflag(2);
                    } else {
                        SavePricingDetails();
                    }
                }}
                visibleSaveBtn={true} btnText={Previewflag == 1 ? 'Continue' : 'Save'} />
            <Popup isshow={ShopifyPopup} size={"sm"} title={"Shopify Information"}
                closePopup={(e) => { setShopifyPopup(false); setShopifyData({ ...shopifyData, pageLink: "", discountCode: "", planid: "" }) }}
                modalBody={shopifymodalBody} handleSave={() => {
                    SaveShopifyDetails();
                }}
                visibleSaveBtn={true} btnText={'Save'} />
            <Deletepopup text={`You won't be able to revert this!`} deletePopup={showdeletepopup} deletePart={DeletePlan} DeleteShowClose={(e) => setshowdeletepopup(false)}></Deletepopup>

            {
                signatureModal == true && (
                    <Popup isshow={signatureModal} size={"md"} title={"Signature"}
                        closePopup={(e) => setSignatureModal(false)}
                        modalBody={signaturemodalbody} handleSave={SaveSignatureCall} visibleSaveBtn={true} btnText={"Save"} />
                )
            }


        </>
    )
}
